import React from 'react';
import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps
} from '@chakra-ui/react';
import { ButtonSize, ButtonVariant } from '../../core/enums';

export type ButtonProps = {
  size?: ButtonSize;
  label: string;
  onClick?: (e?: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  variant?: ButtonVariant;
  rightIcon?: React.ReactElement;
  leftIcon?: React.ReactElement;
  className?: string;
  color?: string;
  backgroundColor?: string;
  dataTestId?: string;
  'data-dd-action-name'?: string;
} & ChakraButtonProps;

export const Button: React.FC<ButtonProps> = ({
  backgroundColor,
  color,
  'data-dd-action-name': rawDataActionNameForDD,
  dataTestId,
  label,
  leftIcon,
  rightIcon,
  className = '',
  disabled = false,
  size = ButtonSize.MD,
  variant = ButtonVariant.PRIMARY,
  ...props
}) => {
  // we have confirmed that all Buttons are not carrying PHI
  // "~" at the beginning signs the action so it will not be redacted
  // we usually draw from labels, but if we don't want to double ~~ if
  // they switch
  const verifiedActionNameForDD = rawDataActionNameForDD || label;
  const signedActionNameForDD = verifiedActionNameForDD.startsWith('~')
    ? verifiedActionNameForDD
    : `~${verifiedActionNameForDD}`;
  return (
    <ChakraButton
      {...props}
      variant={variant}
      disabled={disabled}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      size={size}
      className={className}
      color={color}
      backgroundColor={backgroundColor}
      data-testid={dataTestId?.trim() ?? 'button'}
      data-dd-action-name={signedActionNameForDD}>
      {label}
    </ChakraButton>
  );
};

Button.displayName = 'Button';
